export interface ServerMessage {
  message: string;
  httpStatus: number;
  details?: string;
}
